import React from 'react';
import {CollapsibleItem, Icon, Button, Table} from 'react-materialize'
import {connect} from 'react-redux'
import moment from 'moment'

const getEstimatedTime = (services, allServices) => {
  let estimatedTime = 0;
  services.forEach(service => {
    let foundService = allServices.find(item => item.value === service.type);
    if (foundService) {
      estimatedTime += service.quantity * foundService.time;
    }
  });
    
  estimatedTime = moment.duration(estimatedTime, 'minutes');

  return estimatedTime.humanize();
}

const formatDateTime = (unformattedDate, type) => {
  const dateTimeObject = moment(unformattedDate);
  switch(type) {
    case 'time':
      return dateTimeObject.format('LT'); //2:30 pm
    case 'datetime':
    case 'dateTime':
      return dateTimeObject.format('LLL'); //September 4 1986 8:30 PM
    case 'date':
      return dateTimeObject.format('LL'); //September 4 1986
    case 'full':
      return dateTimeObject.format('LLLL') //Thursday, September 4 1986 8:30 PM
    case 'relative':
      return dateTimeObject.calendar(); //today at 1:30pm
    default:
      return dateTimeObject;
  }
}

const Appointment = ({item, stylists, services, editAppointmentHandler}) => {
  const stylist = stylists.find(stylist => stylist.id.toString() === item.stylist_id.toString());

    return (
      <CollapsibleItem header={`${item.client_name} Date: ${formatDateTime(item.date, 'datetime')}`} icon="date_range" onSelect={()=> {return}}>

        <div className="item_menu">
          <ul>
            <Button waves="orange" className="light-green darken-1" tooltip="Appointment Finished" onClick={() => editAppointmentHandler(item)}>
              <Icon className="white-text" center>event_available</Icon>
            </Button>
            <Button waves="orange" className="red lighten-1" tooltip="Remove Appointment" onClick={() => editAppointmentHandler(item)}>
              <Icon className="white-text" center>event_busy</Icon>
            </Button>
          </ul>
        </div>
  
        <h4><Icon>content_cut</Icon> Stylist: {stylist.firstName} {stylist.lastName}</h4>
        <h5><Icon>face</Icon> Client: {item.client_name}</h5>
        <h5><Icon>schedule</Icon> <strong>Date:</strong> {formatDateTime(item.date, 'date')} <strong>Time:</strong> {formatDateTime(item.date, 'time')}</h5>
      
        <Table>
          <thead>
            <tr>
              <th data-field="service">
              Service
              </th>
              <th data-field="number">
              Number of People
              </th>
            </tr>
          </thead>
          <tbody>

        {item.service.map(service => {
          return (
            <tr key={Math.floor(Math.random() * 100000)}>
              <td>{service.type}</td>
              <td>{service.quantity}</td>
            </tr>
          )
        })}
          </tbody>
        </Table>

       <br />
        Estimated Time: {getEstimatedTime(item.service, services)}
      </CollapsibleItem>
    );
}

const mapStateToProps = state => {
  return {
    stylists: state.stylist.stylists,
    services: state.stylist.services
  }
}

export default connect(mapStateToProps)(Appointment)
